import * as Icon from './icons';
import { type IconProps } from './iconBase';
import { type ComponentType, type FC } from 'react';

// Icon utilities to exclude from the list of icon names
const NON_ICON_KEYS = [
  'Iconize',
  'IconTypes',
  'IconProps',
  'IconBase',
] as const;

type IconKey = typeof Icon;
type NonIconKeys = (typeof NON_ICON_KEYS)[number];

export type IconName = keyof Omit<IconKey, NonIconKeys>;

export const ICON_NAMES = Object.keys(Icon).filter(
  (key) => !NON_ICON_KEYS.includes(key as NonIconKeys),
) as IconName[];

export const getIconComponent = (iconName?: IconName) => {
  if (!iconName) return null;

  return Icon[iconName] as ComponentType<IconProps>;
};

/**
 * Icon component that dynamically renders an icon based on the provided name.
 * Acts as a wrapper around all available Icon in the system, allowing for runtime selection with type safety
 */
export const DynamicIcon: FC<{ name?: IconName } & IconProps> = ({
  name,
  ...iconProps
}) => {
  const IconComponent = getIconComponent(name);

  if (!IconComponent) return null;

  return <IconComponent {...iconProps} />;
};
